<template>
  <div class="ticket-table-card">
    <div class="table-title">{{ticketTableTitle}}</div>
    <el-table :data="ticketInfoTable"
              style="width: 100%"
              max-height="300">
      <!-- 序号 -->
      <el-table-column prop="serialNo"
                       width="50"
                       type="index"
                       :label="this.$t('alarmHistory.index')">
      </el-table-column>
      <!-- 设备编码 -->
      <el-table-column prop="deviceNo"
                       :label="this.$t('equipment.equipmentNumber')"
                       width="150">
        <template slot-scope="scope">
          <span>{{scope.row.deviceNo | maybeEmpty}}</span>
        </template>
      </el-table-column>
      <!-- SN号 -->
      <el-table-column prop="snNo"
                       :label="this.$t('equipment.snNumber')">
        <template slot-scope="scope">
          <span>{{scope.row.snNo | maybeEmpty}}</span>
        </template>
      </el-table-column>
      <!-- 机柜编码 -->
      <el-table-column prop="cabinetNo"
                       :label="this.$t('cabinet.cabinetNumCode')">
        <template slot-scope="scope">
          <span>{{scope.row.cabinetNo | maybeEmpty}}</span>
        </template>
      </el-table-column>
      <!-- 所在U位 -->
      <el-table-column prop="rackUIndex"
                       :label="this.$t('text.belongUbit')">
        <template slot-scope="scope">
          <span>{{scope.row.rackUIndex | maybeEmpty}}</span>
        </template>
      </el-table-column>
      <!-- U数 -->
      <el-table-column prop="uNum"
                       :label="this.$t('equipment.uNo')">
        <template slot-scope="scope">
          <span>{{scope.row.uNum | maybeEmpty}}</span>
        </template>
      </el-table-column>
      <!-- 设备类型 -->
      <el-table-column prop="deviceTypeName"
                       :label="this.$t('equipment.equipmentType')">
        <template slot-scope="scope">
          <span>{{scope.row.deviceType | maybeEmpty}}</span>
        </template>
      </el-table-column>
      <!-- 品牌 -->
      <el-table-column prop="brand"
                       :label="this.$t('text.brand')">
        <template slot-scope="scope">
          <span>{{scope.row.brand | maybeEmpty}}</span>
        </template>
      </el-table-column>
      <!-- 型号 -->
      <el-table-column prop="model"
                       :label="this.$t('text.model')">
        <template slot-scope="scope">
          <span>{{scope.row.model | maybeEmpty}}</span>
        </template>
      </el-table-column>
      <!-- 资产所属 -->
      <el-table-column prop="assetBelongName"
                       :label="this.$t('equipment.assetBelonging')">
        <template slot-scope="scope">
          <span>{{scope.row.assetBelong | maybeEmpty}}</span>
        </template>
      </el-table-column>
      <!-- 现场反馈 -->
      <el-table-column prop="assetBelongName"
                       :label="this.$t('serviceSupport.siteFeedback')">
        <template slot-scope="scope">
          <span>{{scope.row.result | maybeEmpty}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    // info
    ticketInfoTable: {
      type: Array,
      default () { return null; },
    },
    ticketTableTitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    ticketInfoTableCopy () {
      return $.extend(true, [], this.ticketInfo);
    }
  }
};
</script>
<style lang="scss" scoped>
.table-title {
  height: 40px;
  line-height: 40px;
  background-color: #f3f7fb;
  border: 1px solid #d9e1e9;
  font-size: 13px;
  border-bottom: none;
  padding-left: 8px;
}
.ticket-table-card {
  margin: 10px 0 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/workSheet/common/TicketInfoTable.vue